import { pr } from '@/utils/pxToRem';
import { Grid, Stack } from '@mui/material';
import ImgContainer from '../ImgContainer';

const PartnerWrapper = ({ children }: any) => (
  <div
    className="lazyload"
    style={{
      width: '100px',
      // maxHeight: '34px',
      objectFit: 'contain',
    }}
  >
    {children}
  </div>
);

const GoyoloPartner = () => (
  <Grid
    container
    alignItems="center"
    width="100%"
  >
    <Grid
      item
      xs={12}
      sm={12}
      md={7}
    >
      <Stack
        spacing={pr`23px`}
        justifyContent="space-around"
        sx={{
          p: {
            xs: 0,
            md: '0 40px',
          },
        }}
        direction="row"
      >
        <PartnerWrapper>
          <ImgContainer
            src="https://storage.googleapis.com/goyolo-production/partner-vn.png"
            alt="logo"
          />
        </PartnerWrapper>
        <PartnerWrapper>
          <ImgContainer
            src="https://storage.googleapis.com/goyolo-production/partner-vj.png"
            alt="logo"
          />
        </PartnerWrapper>
        <PartnerWrapper>
          <ImgContainer
            src="https://storage.googleapis.com/goyolo-production/partner-qh.png"
            alt="logo"
          />
        </PartnerWrapper>
      </Stack>
      <Stack
        spacing={pr`23px`}
        justifyContent="space-around"
        sx={{
          p: {
            xs: 0,
            md: '0 40px',
          },
        }}
        direction="row"
      >
        <PartnerWrapper>
          <ImgContainer
            src="https://storage.googleapis.com/goyolo-production/partner-vnr.png"
            alt="logo"
          />
        </PartnerWrapper>
        <PartnerWrapper>
          <ImgContainer
            src="https://storage.googleapis.com/goyolo-production/partner-ml.png"
            alt="logo"
          />
        </PartnerWrapper>
      </Stack>
    </Grid>
  </Grid>
);

export default GoyoloPartner;
